var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var CustomLegend = function (_a) {
    var _b;
    var chartData = _a.chartData, colors = _a.colors;
    return (_jsx("div", __assign({ className: "custom-legend  mx-12 py-6" }, { children: (_b = chartData === null || chartData === void 0 ? void 0 : chartData.labels) === null || _b === void 0 ? void 0 : _b.map(function (label, index) { return (_jsxs("div", __assign({ className: "legend-item" }, { children: [_jsx("span", { className: "legend-color", style: { backgroundColor: colors[index] } }), _jsxs("span", __assign({ className: "legend-label" }, { children: [(chartData === null || chartData === void 0 ? void 0 : chartData.legend) ? chartData === null || chartData === void 0 ? void 0 : chartData.legend[index] : label, " (", chartData === null || chartData === void 0 ? void 0 : chartData.data[index], "K)"] }))] }), index)); }) })));
};
export default CustomLegend;
